export default function IconCustomers() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.76408C9.54971 3.13007 10.354 2.73019 11.25 2.73019C12.9069 2.73019 14.25 4.09748 14.25 5.78411C14.25 7.47073 12.9069 8.83802 11.25 8.83802C10.354 8.83802 9.54971 8.43814 9 7.80413M11.25 16.4728H2.25V15.7093C2.25 13.1794 4.26472 11.1284 6.75 11.1284C9.23528 11.1284 11.25 13.1794 11.25 15.7093V16.4728ZM11.25 16.4728H15.75V15.7093C15.75 13.1794 13.7353 11.1284 11.25 11.1284C10.4304 11.1284 9.66189 11.3515 9 11.7413M9.75 5.78411C9.75 7.47073 8.40685 8.83802 6.75 8.83802C5.09315 8.83802 3.75 7.47073 3.75 5.78411C3.75 4.09748 5.09315 2.73019 6.75 2.73019C8.40685 2.73019 9.75 4.09748 9.75 5.78411Z"
        stroke="#3F3F46"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
